import { useAtom, useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { kpiConfigByKeyMapAtom } from '../../../../../services/state/KPIConfigState';
import {
  availableKpiChartsAtom,
  kpiEntitiesToSelectItem,
  kpiKeysToFields,
  selectedKPIChartsByCompanyPrefAtom,
} from '../../../state/ProfileViewSettings';
import { sortGroupableOptions } from '../../../utils/sortGroupableOptions';

export function useAllChartOptions() {
  const allChartKpis = useAtomValue(availableKpiChartsAtom);
  const allChartOptions = allChartKpis.map((field) => {
    return {
      id: field.id,
      entityField: field.entityField,
      value: field.displayName,
      group: field.gridMeta?.group,
    };
  });

  return sortGroupableOptions(allChartOptions);
}

export function useKpiChartsMenu(companyId: number) {
  const [selectedChartsPref, setSelectedChartsPref] = useAtom(selectedKPIChartsByCompanyPrefAtom(companyId));
  const kpisByKey = useAtomValue(kpiConfigByKeyMapAtom);

  const selectedKpis = useMemo(() => {
    if (selectedChartsPref.selectedFields.length > 0) {
      return kpiKeysToFields(selectedChartsPref.selectedFields, kpisByKey);
    }
    return [];
  }, [selectedChartsPref, kpisByKey]);

  const selectedChartOptions = useMemo(() => {
    return kpiEntitiesToSelectItem(selectedChartsPref.selectedFields, kpisByKey);
  }, [kpisByKey, selectedChartsPref.selectedFields]);

  const handleChange = (newValue: string[]) => {
    setSelectedChartsPref({ selectedFields: newValue });
  };

  return { selectedChartOptions, handleChange, selectedKpis };
}
